<template>
  <div class="case-analysis-version-dailog dialog col-block width-full">
    <div class="case-analysis-version-title-container row-block">
      <div class="case-analysis-version-title">{{ $t('DIALOG.caseAnalysisVersion.___title') }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="case-analysis-version-main-container col-block width-full" :style="{ flex: 1 }">
      <div class="case-analysis-version-main-block col-block width-full" v-for="(option, oindex) in mainOptions" :key="oindex" :style="{ flex: 1 }">
        <div class="case-analysis-version-main-title-container row-block">
          <div class="case-analysis-version-main-title" v-html="option.title"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div class="case-analysis-version-main-content-container col-block width-full" :style="{ flex: 1 }">
          <caseDetailAnalysisVersionTable
            :defaultDatas="option.tableDatas"
          ></caseDetailAnalysisVersionTable>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import caseDetailAnalysisVersionTable from '../caseDetail/analysisVersionTable.vue'
import { versionDatas } from '../../constants/global/data'

export default {
  components: {
    caseDetailAnalysisVersionTable
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // static
    mainOptions () {
      const tableDataParse = datas => datas.filter(data => this.analysisVersions[data.version] && (!data.display || data.display.includes('case'))).map(data => ({
        category: this.$t(data.category),
        name: this.$t(data.name),
        version: this.analysisVersions[data.version],
        systemVersion: this.systemVersions[data.systemVersion]
      }))
      return [
        {
          title: this.$t('DIALOG.caseAnalysisVersion.mainData.title.___pipeline'),
          tableDatas: tableDataParse(versionDatas['pipeline'])
        },
        {
          title: this.$t('DIALOG.caseAnalysisVersion.mainData.title.___analysis'),
          tableDatas: tableDataParse(versionDatas['analysis'])
        }
      ]
    },
    // param
    analysisVersions () {
      return {
        ...this.param.analysisVersions
      }
    },
    systemVersions () {
      return {
        ...this.param.softwareVersions,
        ...this.param.systemVersions
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseAnalysisVersion.vue